.wrapper {
  flex-direction: column;

  .loading-container {
    display: none;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    gz-progress-spinner {
      display: flex;
      justify-content: center;
    }
  }

  &.is-loading {
    .form-wrapper {
      display: none;
    }

    .loading-container {
      display: flex;
    }
  }

  &.is-error {
    .form-wrapper {
      display: none;
    }
    .loading-error {
      display: block;
    }
  }

  .form-wrapper {
    min-width: 500px;
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    padding: 16px calc(4 * var(--spacer)) 0;
  }
}

.bottom-buttons {
  width: 100%;
  flex-basis: 55px;
  min-height: 55px;
  margin-top: auto;
  display: flex;
  align-items: center;

  border-top: 1px solid var(--chart-101-pressed-dividers);
  padding: calc(1.75 * var(--spacer)) calc(2 * var(--spacer));

  gz-button {
    margin-right: calc(var(--spacer) * 2);
  }
}
